import { ListLayout } from 'components/common/ListLayout'
import React, { useEffect, useState } from "react";
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, FormProvider, set, useController, useForm, useFormContext, useWatch } from 'react-hook-form';
import { DialogTitle, Switch } from '@mui/material';
import { BootstrapDialog } from 'components/languageTiers/AddLanguageTiers';
import ErrorMessage from 'components/common/ErrorMessage';
import moment from 'moment';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { fetchInterpreterRates } from 'slices/inviteInterpreterSlice';
import { submitApptCustomWorkOrder } from 'slices/inviteInterpreterSlice';
import { fetchInvitedInterpreters } from 'slices/inviteInterpreterSlice';
const CustomWorkOrderModal = ({ item, show, onClose }) => {
  const dispatch = useDispatch()
  const defaultValues = {
    mileage: "",
    mileage_rate: "",
    travel_hours: "",
    travel_rate: "",
    duration_rate: 0,
    min_duration: 0,
    session_total: "0.00",
    total: "0.00",
    // discount: "0",
    // appointment_total: "0.00",
    custom_pricing: 1,
  }



  const methods = useForm({
    defaultValues
  });


  const onSubmit = (data) => {
    data.appointment_id = item?.appt_id
    data.interpreter_id = item?.id
    submitApptCustomWorkOrder(
      data, (success, message, data) => {
        if (success) {
          toast.success(message)
          methods.reset(defaultValues)
          onClose(); // or whatever callback you want
          dispatch(fetchInvitedInterpreters(item?.appt_id))
        }
        else {
          toast.error(message)
        }
      }
    )
  }

  return (
    <BootstrapDialog
      fullWidth
      maxWidth="md"
      open={show}
      onClose={(e, reason) => {
        if (reason !== "backdropClick") onClose();
      }}
      sx={{
        "& .MuiDialog-container": { alignItems: "flex-start", padding: "2rem" },
        "& .MuiPaper-root": { overflowY: "visible", margin: "auto" },
      }}
    >
      <div className="modal-content full_modal">
        <DialogTitle>
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">Custom Work Order</h5>
            <button onClick={onClose} type="button" className="btn-close" />
          </div>
        </DialogTitle>
        <div className="modal-body modal_form_body">
          <FormProvider {...methods}>
            <CustomWorkOrder
              item={item}
              onClose={onClose}
              onSubmit={methods.handleSubmit(onSubmit)}
            />
          </FormProvider>
        </div>
      </div>
    </BootstrapDialog>
  );
};


const CustomWorkOrder = ({ item, onClose, onSubmit }) => {
  const dispatch = useDispatch();
  // const { error, loader } = useSelector(appointmentsSelector);


  const { control, formState: { errors }, clearErrors, watch, setValue, } = useFormContext();
  const type = useWatch({ control, name: "custom_pricing" });
  const startTime = watch("start_time");
  const endTime = watch("end_time");
  const estimatedDuration = watch("estimated_duration");
  const mileage = useWatch({ control, name: "mileage" });
  const mileage_rate = useWatch({ control, name: "mileage_rate" });
  const travel_hours = useWatch({ control, name: "travel_hours" });
  const travel_rate = useWatch({ control, name: "travel_rate" });
  const duration_rate = useWatch({ control, name: "duration_rate" });
  // const discount = useWatch({ control, name: "discount" });
  const min_duration = useWatch({ control, name: "min_duration" });
  // Function to calculate end time
  const calculateEndTime = (startTime, duration) => {
    if (!startTime || !duration) return "";
    const startMoment = moment(startTime, "HH:mm");
    return startMoment.add(duration, "minutes").format("HH:mm");
  };


  // fetch duration and rate

  useEffect(() => {

    async function fetchRates(params) {
      fetchInterpreterRates(item?.appt_id, item?.id, (success, message, data) => {
        if (success && data) {

          const {
            duration, rate,
            duration_rate, min_duration
          } = data

          duration || min_duration && setValue("min_duration", (duration || min_duration))
          rate || duration_rate && setValue("duration_rate", (rate || duration_rate))
        }

        else {
          toast.error("Error while fetching duration rate" + ". " + "message")
        }


      })
    }
    fetchRates()

  }, [])

  console.log("min_duration", min_duration)



  // Update end time when estimated duration changes

  useEffect(() => {
    if (startTime && estimatedDuration) {
      setValue("end_time", calculateEndTime(startTime, estimatedDuration));
    }
  }, [startTime, estimatedDuration, setValue]);

  useEffect(() => {
    setValue("date", moment().format("YYYY-MM-DD"));
    setValue("start_time", moment().format("HH:mm"));
    setValue("estimated_duration", 1);
  }, []);

  useEffect(() => {
    if (watch("custom_pricing") !== 1) {
      // Reset all pricing fields
      setValue("mileage", "");
      setValue("mileage_rate", "");
      setValue("mileage_total", "0.00");

      setValue("travel_hours", "");
      setValue("travel_rate", "");
      setValue("travel_total", "0.00");

      setValue("duration_rate", "");
      setValue("min_duration", "");
      setValue("session_total", "0.00");

      // setValue("discount", "0");
      setValue("total", "0.00");
      // setValue("appointment_total", "0.00");
    }
  }, [type]);

  useEffect(() => {
    const mileageTotal =
      (parseFloat(mileage) || 0) * (parseFloat(mileage_rate) || 0);
    setValue("mileage_total", mileageTotal.toFixed(2));

    const travelTotal =
      parseFloat(travel_hours || 0) * parseFloat(travel_rate || 0);
    setValue("travel_total", travelTotal.toFixed(2));

    // setValue("duration_rate", 0);
    // setValue("min_duration", 0);

    const sessionTotal =
      parseFloat(min_duration || 0) * parseFloat(duration_rate || 0);
    setValue("session_total", sessionTotal.toFixed(2));

    const subTotal = mileageTotal + travelTotal + sessionTotal;
    setValue("total", subTotal.toFixed(2));

    // const discountValue = subTotal * (parseFloat(discount || 0) / 100);
    // const appointmentTotal = subTotal - discountValue;
    // setValue("appointment_total", appointmentTotal.toFixed(2));
  }, [
    mileage,
    mileage_rate,
    travel_hours,
    travel_rate,
    duration_rate,
    min_duration,
    // discount,
    0,
    0,
  ]);



  return (
    <div className="step_cards">
      <div className="w-100 custom_pricing">
        {/* Row 1 - Mileage */}
        <div className="row d-flex justify-content-between mb-3">
          <div className="col-md-4">
            <div className="row-primary mb-2">
              <h2>Mileage (km)</h2>
            </div>
            <Controller
              name="mileage"
              control={control}
              rules={{
                required: "Mileage is required",
                max: { value: 99999, message: "Max 5 digits" },
                pattern: {
                  value: /^\d{1,5}(\.\d{1,2})?$/,
                  message: "Up to 5 digits and 2 decimals allowed",
                },
              }}
              render={({ field }) => (
                <div className="input-image">
                  <input type="number" placeholder="Mileage" {...field} />
                </div>
              )}
            />
            {errors.mileage?.message && (
              <ErrorMessage text={errors.mileage.message} />
            )}
          </div>

          <div className="col-md-4">
            <div className="row-primary mb-2">
              <h2>Mileage Rate</h2>
            </div>
            <Controller
              name="mileage_rate"
              control={control}
              rules={{
                required: "Mileage Rate is required",
                max: { value: 99999, message: "Max 5 digits" },
                pattern: {
                  value: /^\d{1,5}(\.\d{1,2})?$/,
                  message: "Up to 5 digits and 2 decimals allowed",
                },
              }}
              render={({ field }) => (
                <div className="input-image">
                  <input type="number" placeholder="Rate per km" {...field} />
                </div>
              )}
            />
            {errors.mileage_rate?.message && (
              <ErrorMessage text={errors.mileage_rate.message} />
            )}
          </div>

          <div className="col-md-4">
            <div className="row-primary mb-2">
              <h2>Mileage Total</h2>
            </div>
            <Controller
              name="mileage_total"
              control={control}
              rules={{ required: "Mileage Total is required" }}
              render={({ field }) => (
                <div className="input-image">
                  <input
                    type="number"
                    placeholder="Mileage Total"
                    readOnly
                    {...field}
                  />
                </div>
              )}
            />
            {errors.mileage_total?.message && (
              <ErrorMessage text={errors.mileage_total.message} />
            )}
          </div>
        </div>

        {/* Row 2 - Travel */}
        <div className="row d-flex justify-content-between mb-3">
          <div className="col-md-4">
            <div className="row-primary mb-2">
              <h2>Travel (hrs)</h2>
            </div>
            <Controller
              name="travel_hours"
              control={control}
              rules={{
                required: "Travel Hours is required",
                max: { value: 99999, message: "Max 5 digits" },
                pattern: {
                  value: /^\d{1,5}(\.\d{1,2})?$/,
                  message: "Up to 5 digits and 2 decimals allowed",
                },
              }}
              render={({ field }) => (
                <div className="input-image">
                  <input type="number" placeholder="Travel Hours" {...field} />
                </div>
              )}
            />
            {errors.travel_hours?.message && (
              <ErrorMessage text={errors.travel_hours.message} />
            )}
          </div>

          <div className="col-md-4">
            <div className="row-primary mb-2">
              <h2>Travel Hourly Rate</h2>
            </div>
            <Controller
              name="travel_rate"
              control={control}
              rules={{
                required: "Travel Hourly Rate is required",
                max: { value: 99999, message: "Max 5 digits" },
                pattern: {
                  value: /^\d{1,5}(\.\d{1,2})?$/,
                  message: "Up to 5 digits and 2 decimals allowed",
                },
              }}
              render={({ field }) => (
                <div className="input-image">
                  <input type="number" placeholder="Rate per Hour" {...field} />
                </div>
              )}
            />
            {errors.travel_rate?.message && (
              <ErrorMessage text={errors.travel_rate.message} />
            )}
          </div>

          <div className="col-md-4">
            <div className="row-primary mb-2">
              <h2>Travel Total</h2>
            </div>
            <Controller
              name="travel_total"
              control={control}
              render={({ field }) => (
                <div className="input-image">
                  <input
                    type="number"
                    placeholder="Travel Total"
                    {...field}
                    readOnly
                  />
                </div>
              )}
            />
          </div>
        </div>

        {/* Row 3 - Duration */}
        <div className="row d-flex justify-content-between mb-3">
          <div className="col-md-4">
            <div className="row-primary mb-2">
              <h2>Duration (hrs)</h2>
            </div>
            <Controller
              name="min_duration"
              control={control}
              render={({ field }) => (
                <div className="input-image">
                  <input
                    type="number"
                    placeholder="Min Duration"
                    {...field}
                    
                  />
                </div>
              )}
            />
          </div>

          <div className="col-md-4">
            <div className="row-primary mb-2">
              <h2>Rate (per hr)</h2>
            </div>
            <Controller
              name="duration_rate"
              control={control}
              render={({ field }) => (
                <div className="input-image">
                  <input
                    type="number"
                    placeholder="Rate per Hour"
                    {...field}
                  />
                </div>
              )}
            />
          </div>

          <div className="col-md-4">
            <div className="row-primary mb-2">
              <h2>Session Total</h2>
            </div>
            <Controller
              name="session_total"
              control={control}
              render={({ field }) => (
                <div className="input-image">
                  <input
                    type="number"
                    placeholder="Session Total"
                    {...field}
                    readOnly
                  />
                </div>
              )}
            />
          </div>
        </div>

        <div className="row d-flex justify-content-between mb-3">
          <div className="col-md-4"></div>
          <div className="col-md-4"></div>

          <div className="col-md-4">
            <div className="row-primary">
              <h2>Total</h2>
            </div>
            <Controller
              name="total"
              control={control}
              render={({ field }) => (
                <div className="input-image">
                  <input
                    type="number"
                    placeholder="Subtotal"
                    {...field}
                    readOnly
                  />
                </div>
              )}
            />
          </div>
        </div>

        {/* <div className="row d-flex justify-content-between mb-3">
          <div className="col-md-4"></div>
          <div className="col-md-4"></div>

          <div className="col-md-4">
            <div className="row-primary mb-2">
              <h2>% Discount</h2>
            </div>
            <Controller
              name="discount"
              control={control}
              defaultValue={0}
              rules={{
                min: { value: 0, message: "Min 0%" },
                max: { value: 100, message: "Max 100%" },
                pattern: {
                  value: /^([0-9]{1,2}|100)$/,
                  message: "Must be between 0 and 100",
                },
              }}
              render={({ field }) => (
                <div className="input-image">
                  <input type="number" placeholder="Discount %" {...field} />
                </div>
              )}
            />
            {errors.discount?.message && (
              <ErrorMessage text={errors.discount.message} />
            )}
          </div>
        </div>

        <div className="row d-flex justify-content-between mb-3">
          <div className="col-md-4"></div>
          <div className="col-md-4"></div>

          <div className="col-md-4">
            <div className="row-primary mb-2">
              <h2>Total</h2>
            </div>
            <Controller
              name="appointment_total"
              control={control}
              render={({ field }) => (
                <div className="input-image">
                  <input
                    type="number"
                    placeholder="Total"
                    {...field}
                    readOnly
                  />
                </div>
              )}
            />
          </div>
        </div> */}
        <div className="row d-flex justify-content-between mb-3 mt-4">
          <div className="col-md-12">


            <div className="Form-footer">
              <button type="button" className="Cancle_button" onClick={onClose}>Cancel</button>
              <SubmitButton
                btnText={"Create"}
                handleSubmit={onSubmit}

              // loader={loader}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};



export default CustomWorkOrderModal